//=================================================
//    summary: DCP 設定 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/12 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssSettings from './Settings.module.scss'
import Account from './Units/Account/Account'
import Subscription from './Units/Subscription/Subscription'
import Content from './Units/Content/Content'
import Time from './Units/Time/Time'
import About from './Units/About/About'
import {LoadingMask, AlertWindow, GlobalLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false

let mstrDisplayName = ""
let mobjSettingsDirty = {
    // "ProfileEdit": false,
    // "PasswordChang": false,
    // "SubscriptionUpdate": false,
    "LangChange": false
}
// #endregion Member Variables

// #region Enumeration
const MenuTypeEnum = {
    "Account": 1,           // 帳號
    "Subscription": 2,      // 購買
    "Content": 3,           // 課程內容
    "Time": 4,              // 時間
    "About": 5              // 關於
}
// #endregion Enumeration


const COMP_NAME = "Settings"

function Settings(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [menuType, setMenuType] = useState(1)
    
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mstrDisplayName = window.Globals.GetDisplayName()

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false

            mobjSettingsDirty = {
                // "ProfileEdit": false,
                // "PasswordChang": false,
                // "SubscriptionUpdate": false,
                "LangChange": false
            }

            setMenuType(1)
        }
    }, [props.AuthorizedSubscription])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowSettings",
            "SettingsDirty": mobjSettingsDirty
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 左邊選單
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function MenuButtonOnTapHandler(DisplayMenuType)
    {
        console.log(COMP_NAME + ".MenuButtonOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setMenuType(DisplayMenuType)
    } // end of MenuButtonOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "GoToLearningUnit4Settings")
        {
            let objCallbackData = {
                "Action": "GoToLearningUnit4Settings",
                "LocationState": CallbackObj.LocationState
            }
            props.CallbackRef(objCallbackData)
        }
        else if (CallbackObj.Action === "OpenShowResource4NoAuthorized")
        {
            let objCallbackData = {
                "Action": "OpenShowResource4NoAuthorized"
            }
            props.CallbackRef(objCallbackData)
        }
        else if (CallbackObj.Action === "LangChange")
        {
            mobjSettingsDirty.LangChange = true
        }
        else if (CallbackObj.Action === "AssignReport4NoAuthorized")
        {
            let objCallbackData = {
                "Action": "AssignReport4NoAuthorized"
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (
            (typeof(props.AuthorizedSubscription) !== 'undefined') &&
            (props.AuthorizedSubscription !== null) &&
            (typeof(props.AuthorizedSubscription.BookCatID) !== 'undefined') &&
            (props.AuthorizedSubscription.BookCatID !== null) &&
            (parseInt(props.AuthorizedSubscription.BookCatID) > 0) &&
            (typeof(props.AuthorizedSubscription.BookSeqNo) !== 'undefined') &&
            (props.AuthorizedSubscription.BookSeqNo !== null) &&
            (parseInt(props.AuthorizedSubscription.BookSeqNo) > 0)
            )
        {
            setMenuType(MenuTypeEnum.Subscription)
        }
        else
        {
            setMenuType(1)
        }
    } // end of PaintedMe

    /*===========================================
    summary: 取得 選單按鈕 顯示物件
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetMenuButtonDisplayObject(DisplayMenuType)
    {
        let objDisplay = {
            "IconCls": null,
            "Text": ""
        }

        switch (DisplayMenuType)
        {
            case MenuTypeEnum.Subscription:
                objDisplay.IconCls = cssSettings.divSubscriptionIcon
                objDisplay.Text = window.gAppUI.LBL_Subscription
                break
            case MenuTypeEnum.Content:
                objDisplay.IconCls = cssSettings.divContentIcon
                objDisplay.Text = window.gAppUI.LBL_Content
                break
            case MenuTypeEnum.Time:
                objDisplay.IconCls = cssSettings.divTimeIcon
                objDisplay.Text = window.gAppUI.LBL_Time
                break
            case MenuTypeEnum.About:
                objDisplay.IconCls = cssSettings.divAboutIcon
                objDisplay.Text = window.gAppUI.LBL_About
                break
            case MenuTypeEnum.Account:
            default:
                objDisplay.IconCls = cssSettings.divAccountIcon
                objDisplay.Text = window.gAppUI.LBL_Account
                break
        } // end of switch (DisplayMenuType)

        return objDisplay
    } // end of GetMenuButtonDisplayObject
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 Menu Button Cls
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetMenuButtonCls(StateMenuType, DisplayMenuType)
    {
        let objCls = cssSettings.divMenuButton

        if (StateMenuType === DisplayMenuType)
        {
            objCls = cssSettings.divMenuButtonSelected
        }

        return objCls
    } // end of GetMenuButtonCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Menu Button 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentMenuButton( {StateMenuType, DisplayMenuType} )
    {   
        let objDisplay = GetMenuButtonDisplayObject(DisplayMenuType)

        return(
            <div className={GetMenuButtonCls(StateMenuType, DisplayMenuType)} onClick={() => MenuButtonOnTapHandler(DisplayMenuType)}>
                <div className={objDisplay.IconCls}/>
                <div className={cssSettings.divMenuButtonText}>
                    {objDisplay.Text}
                </div>
            </div>
        )
    } // end of ComponentMenuButton

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2022/01/17 將 Close 感應區改大
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssSettings.btnCloseMain} onClick={() => CloseOnTapHandler()}>
                <div className={cssSettings.btnCloseIcon}/>
            </div>
        )
    } // end of ComponentCloseButton

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssSettings.divTitle}>
                {window.gAppUI.LBL_Settings}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentDisplayName( {DisplayName} )
    {   
        return(
            <div className={cssSettings.divDisplayName}>
                {DisplayName}
            </div>
        )
    } // end of ComponentCloseButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 右方 內容 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderSubContentWrapper(StateMenuType)
    {
        let objSubContentBlock = ""
        switch (StateMenuType)
        {
            case MenuTypeEnum.Subscription:
                objSubContentBlock = <Subscription AuthorizedSubscription={props.AuthorizedSubscription}
                                        CallbackRef={ComponentCallback}/>
                break
            case MenuTypeEnum.Content:
                objSubContentBlock = <Content ClassIndex={window.gSession.Acc.CurrentClassIndex} 
                                        CallbackRef={ComponentCallback}/>
                break
            case MenuTypeEnum.Time:
                objSubContentBlock = <Time CallbackRef={ComponentCallback}/>
                break
            case MenuTypeEnum.About:
                objSubContentBlock = <About />
                break
            case MenuTypeEnum.Account:
            default:
                objSubContentBlock = <Account CallbackRef={ComponentCallback}/>
                break
        }

        return (
            <div className={cssSettings.divSubContent}>
                {objSubContentBlock}
            </div>
        )
    } // end of RenderSubContentWrapper

    /*===========================================
    summary: Render 左方 選單 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderMenuWrapper(StateMenuType)
    {
        return (
            <div className={cssSettings.divMenu}>
                <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.Account}/>
                <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.Subscription}/>
                <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.Content}/>
                {/* 已改用 Richard寫的 計算時間，以防會有 日光節約時間的偏差    Tim21.12.23 */}
                {/* <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.Time}/> */}
                <ComponentMenuButton StateMenuType={StateMenuType} DisplayMenuType={MenuTypeEnum.About}/>
            </div>
        )
    } // end of RenderMenuWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssSettings.divContent}>
                {RenderMenuWrapper(menuType)}
                {RenderSubContentWrapper(menuType)}
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssSettings.divTopTool}>
                <ComponentDisplayName DisplayName={mstrDisplayName}/>

                <ComponentTitle />
                
                <ComponentCloseButton />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssSettings.divMain}>
                {RenderTopToolWrapper()}
                {RenderContentWrapper()}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default Settings